export const NVD_PASSWORDLESS_LOGIN_EXPERIMENT = 'nvd_passwordless_login';
